import { h, Fragment } from "preact";
import SwatchProduct from "./swatch-product";
import { otherGroup } from "./otherGroup";

export default function SwatchModalGroup({
  products,
  groupName,
  cartItems,
  limitEach,
  swatchType,
}) {
  return (
    <div className="pdp-swatch-modal__product-group">
      {groupName && groupName !== otherGroup && (
        <div className="pdp-swatch-modal__product-group-name">{groupName}</div>
      )}
      <div className="pdp-swatch-modal__products">
        {products.map((product) => (
          <SwatchProduct
            product={product}
            cartItems={cartItems}
            limitEach={limitEach}
            swatchType={swatchType}
          />
        ))}
      </div>
    </div>
  );
}
